import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';
import { TodoStates } from '@fi-app/fi-onboarding/fi-todo/fi-todo-states';
import { FiTodoService } from '@fi-app/fi-onboarding/fi-todo/fi-todo.service';
import { FiTodoListModule } from '@fi-app/fi-onboarding/fi-todo/fi-todo-list/fi-todo-list.module';
import { FiTodoEditModule } from '@fi-app/fi-onboarding/fi-todo/fi-todo-edit/fi-todo-edit.module';
import { FiTodoHelperService } from '@fi-app/fi-onboarding/fi-todo/fi-todo-helper.service';
import { FiTodoActionsBuilderService } from '@fi-app/fi-onboarding/fi-todo/fi-todo-actions-builder.service';
import { FiTodoViewModule } from '@fi-app/fi-onboarding/fi-todo/fi-todo-view/fi-todo-view.module';

@NgModule({
    imports: [CommonModule, UIRouterModule.forChild(TodoStates), FiTodoListModule, FiTodoEditModule, FiTodoViewModule],
    declarations: [],
    providers: [FiTodoService, FiTodoHelperService, FiTodoActionsBuilderService],
})
export class FiTodoModule {}
